import { FC, useEffect, useState } from 'react'
import './Onboarding.scss'
import React from 'react'

type OnboardingQuestion = {
  questionId: string;
  title: string;
  subTitle: string;
  options: string[];
  subQuestions: OnboardingQuestion[]
  answer?:  string | null | Record<string, string>;
}

type CompoundMultipleSelectProps = {
  data: OnboardingQuestion
  setIsDisable: (value: boolean) => void;
  onSubmit: (answer: string | null | Record<string, string>) => void;
}

const CompoundMultipleSelect: FC<CompoundMultipleSelectProps> = ({ data, onSubmit, setIsDisable }) => {
  const selectedAnswer = data.subQuestions.map(sub => {
    return {
      [sub.questionId]: typeof sub.answer === 'object' && sub.answer !== null
        ? (sub.answer as Record<string, string>).answer
        : sub.answer
    }
  })
  const defaultSelected = Object.assign({}, ...selectedAnswer);
  const [subSelections, setSubSelections] = useState<Record<string, string>>(defaultSelected ?? {});

  const handleSubChange = (questionId: string, option: string) => {
    const nonNullCount = Object.values(subSelections).filter(value => value !== null).length;

    if ((nonNullCount + 1) === data.subQuestions.length) {
      setIsDisable(false);
    }

    setSubSelections(prev => ({ ...prev, [questionId]: option }));
    onSubmit({...subSelections, [questionId]: option })
  };

  useEffect(() => {
    const nonNullCount = Object.values(subSelections).filter(value => value !== null).length;
    if (nonNullCount === data.subQuestions.length) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAnswer]);


  return (
    <>
      <div className='fw-boldest fs-3'>{data.title}</div>
      <div className='onboarding-description'>{data.subTitle}</div>
      <table className='table align-middle gs-0 gy-3 mt-5'>
        <thead className='table-header'>
          <tr>
            <th className='min-w-150px text-center'>Business Goals</th>
            <th className='w-40px text-center'>1</th>
            <th className='w-40px text-center'>2</th>
            <th className='w-40px text-center'>3</th>
            <th className='w-40px text-center'>4</th>
            <th className='w-40px text-center'>5</th>
            <th className='w-40px text-center'>NA</th>
          </tr>
        </thead>
        <tbody>
          {data.subQuestions.map((question, index) => (
            <tr key={index}>
              <td>
                <div className='symbol symbol-50px me-2 option-label'>
                  {question.title}
                </div>
                {/* Todo: use later
                  <div className='onboarding-description'>{question.subTitle}</div>
                */}
              </td>
              {question.options.map((opt) => (
                <td key={opt}>
                  <div
                    key={opt}
                    className='form-check form-check-custom form-check-solid mb-5'
                    onChange={() => handleSubChange(question.questionId, opt)}
                  >
                    <input
                      className='form-check-input widget-9-check radio-input'
                      type='checkbox'
                      id={`${index}-${opt}`}
                      name={`sub-${question.questionId}`}
                      value={opt}
                      checked={subSelections[question.questionId] === opt}
                      onChange={() => handleSubChange(question.questionId, opt)}
                    />
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default React.memo(CompoundMultipleSelect)
